import { render, staticRenderFns } from "./About.vue?vue&type=template&id=7df6e6c6&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=7df6e6c6&prod&lang=sass&"
import style1 from "./About.vue?vue&type=style&index=1&id=7df6e6c6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df6e6c6",
  null
  
)

export default component.exports